// const basename = '/backend/pink-panther-pos/website';
const basename = '/';

export {basename};